export default __webpack_public_path__ + "static/media/index_document.ef1b9291.svg";